import Question from '@components/CMS/FAQ/Question'
import { faqSerializedType } from './types'

const StandAloneFAQ = ({
  title,
  faqs,
}: {
  title: string
  faqs: faqSerializedType[]
}) => {
  return (
    <div className="bg-[#F5F5F5] py-16">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl font-bold leading-10 tracking-tight text-gray-900 mb-8 text-center">
          {title} FAQs
        </h2>
        <dl className="mt-10 space-y-6 divide-y divide-gray-900/10">
          {faqs.map((faq) => (
            <Question key={faq.question} {...faq} />
          ))}
        </dl>
      </div>
    </div>
  )
}

export default StandAloneFAQ
